import ICustomer from "../../interfaces/customer/ICustomer"
import IEntityIncident from "../../interfaces/entityIncident/IEntityIncident"

const ActionIsAllowedOnIncidents = (customer:ICustomer, entityIncidents: IEntityIncident[], actionName:string):boolean => 
{
  let isAllowed = false

  entityIncidents.map(entityIncidentFromList => {

    isAllowed = false

    customer.sense.incidentTypes.filter(incidentType_inner => incidentType_inner.name === entityIncidentFromList.incident.name).map(incidentType => (
      incidentType.actions && incidentType.actions.map(name => {
        if (name == actionName) isAllowed = true
      })    
    ))

    if (isAllowed == false) return false
  })

  return isAllowed;
}

export default ActionIsAllowedOnIncidents